import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { MetricProps, formatMetricValue } from '../../utils';
import { FunctionData } from '@hud/portal-dtos/webapp-function.dto';
import { Endpoint } from '@hud/portal-dtos/webapp-endpoint.dto';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';
import { MessageQueue } from '@hud/portal-dtos/webapp-message-queue.dto';

export function formatFunctionMetric<
  TData extends FunctionData | Endpoint | MessageQueue,
>(format: MetricProps['format']) {
  return function cellFormatter(cell: CellContext<TData, number>) {
    const value: number = cell.getValue();
    return formatMetricValue({
      value,
      format,
    });
  };
}

export default function renderFunctionMetric<
  TData extends FunctionData | Endpoint | MessageQueue,
  TValue extends number,
>(format: MetricProps['format']) {
  const formatMetric = formatFunctionMetric<TData>(format);
  return function cellRenderer(cell: CellContext<TData, TValue>) {
    const normalized = formatMetric(cell);
    return <LongContentPopover>{normalized}</LongContentPopover>;
  };
}
